import React from 'react';
import styles from './styles.scss';
import cn from 'classnames';
import { ImageContainer } from './image';
import { CardLayoutProps } from './types';

export const CardLayout = ({
  image,
  categoryUrl,
  appearance = 'card',
  children,
  section,
  path,
  hasSpacing
}: CardLayoutProps) => {
  const isCard = appearance === 'card';
  const content = (
    <div
      className={cn(styles.container, {
        [styles.large]: isCard
      })}
    >
      <ImageContainer path={path} image={image} />
      {!!section && section}
      <div
        className={cn(styles.buttonLayout, {
          [styles.card]: isCard,
          [styles.spacing]: hasSpacing
        })}
      >
        {children}
      </div>
    </div>
  );

  return categoryUrl ? <a href={categoryUrl}>{content}</a> : <span>{content}</span>;
};
